module.exports = __webpack_public_path__ + "static/media/utilities.da26fd9b.svg";